<template>
  <div>
    <v-row>
      <v-col md="12" cols="12">
        <v-toolbar class="mb-2" color="primary" dark flat>
          <v-toolbar-title>{{ reportTitle }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col v-if="!isTypZrazky">
        <v-autocomplete
          label="Lokalita"
          v-model="filterLokalitaId"
          :items="lokality"
          item-text="Name"
          item-value="ID"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col v-if="isTypZrazky">
        <v-autocomplete
          label="Stanica SHMÚ"
          v-model="filterStanicaId"
          :items="stanice"
          item-text="Stanica"
          item-value="ID"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col v-if="!isTypZrazky">
        <v-autocomplete
          label="Bod"
          v-model="filterBodId"
          :items="body"
          item-text="ZNMB"
          item-value="ID"
          clearable
          multiple
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.ZNMB }} - {{ item.IDMB }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <b>Dátum od:</b> {{ item.DatumOdString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <b>Dátum do:</b> {{ item.DatumDoString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col>
        <date-picker
          v-model="filterDatumOd"
          label="Dátum od"
          name="filterDatumOd"
        ></date-picker>
      </v-col>
      <v-col>
        <date-picker
          v-model="filterDatumDo"
          label="Dátum do"
          name="filterDatumDo"
        ></date-picker>
      </v-col>
      <v-col v-if="typ === 'ink'">
        <v-text-field
          v-model="filterHlbky"
          label="Hĺbky"
          name="filterHlbky"
          hint="Hodnoty oddelené čiarkou, napr.: 1.5,2,2.5,3"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-btn @click="showReport()">Zobraziť report</v-btn>
      </v-col>
    </v-row>
    <!--
    <v-row>
      filterLokalitaId: {{ filterLokalitaId }}, filterBodId: {{ filterBodId }}
    </v-row>
    <v-row> Items: {{ items }} </v-row>
    -->
    <v-row v-if="items.length > 0">
      <v-col md="12" cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" v-for="item in itemsHeaders" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td v-for="(i, indexI) in item" :key="index + '_' + indexI">
                  {{ i }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <download-excel
              :data="exportItems"
              class="exportXLS"
              :name="`report${typ}.xls`"
            >
              <v-icon v-on="on">mdi-microsoft-excel</v-icon>
            </download-excel>
          </template>
          <span>Export do xls</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-else>
      <div class="text-center" style="width: 100%" v-if="loading">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <v-col v-else md="12" cols="12" class="d-flex justify-center">
        <span class="info--text">
          Report neobsahuje žiadne údaje.
        </span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DatePicker from "../components/DatePicker.vue"
import * as Miscella from "../plugins/miscella.js"
import DownloadExcel from "vue-json-excel"

export default {
  components: { DatePicker, DownloadExcel },
  data: function() {
    return {
      loading: false,
      filterDatumDo: "",
      filterDatumOd: "",
      filterLokalitaId: "",
      filterStanicaId: "",
      filterBodId: [],
      filterHlbky: "",
      items: [],
      itemsHeaders: [],
      lokality: [],
      stanice: [],
      body: []
    }
  },
  computed: {
    typ: function() {
      return this.$route.params.typ
    },
    isTypZrazky: function() {
      return this.typ.startsWith("zrazky")
    },
    reportTitle: function() {
      let ret = ""
      if (this.typ === "geo") {
        ret = "Geodézia"
      }
      if (this.typ === "hpv") {
        ret = "Hladiny podzemnej vody"
      }
      if (this.typ === "hpvt") {
        ret = "Teploty podzemnej vody"
      }
      if (this.typ === "ink") {
        ret = "Inklinometria"
      }
      if (this.typ === "q") {
        ret = "Výdatnosť odv. zariadení"
      }
      if (this.typ === "pt") {
        ret = "Pórové tlaky"
      }
      if (this.typ === "zrazky1") {
        ret = "Zrážkové úhrny 1"
      }
      if (this.typ === "zrazky2") {
        ret = "Zrážkové úhrny 2"
      }
      if (this.typ === "zrazky3") {
        ret = "Počet mrazových dní"
      }
      return "Report - " + ret
    },
    merTable: function() {
      let ret = ""
      if (this.typ === "geo") {
        ret = "mer_geo"
      }
      if (this.typ === "hpv") {
        ret = "mer_hpv"
      }
      if (this.typ === "hpvt") {
        ret = "mer_hpv"
      }
      if (this.typ === "q") {
        ret = "mer_q"
      }
      if (this.typ === "pt") {
        ret = "mer_pt"
      }
      return ret
    },
    exportItems: function() {
      let items = []
      for (let i = 0; i < this.items.length; i++) {
        let itemRow = this.items[i]
        let obj = []
        for (let j = 0; j < itemRow.length; j++) {
          let item = itemRow[j]
          obj[this.itemsHeaders[j]] = item
        }
        console.log("OBJ", obj)
        items.push(obj)
      }
      console.log("items", items)
      return items
    }
  },
  watch: {
    typ: {
      immediate: true,
      handler: function() {
        console.log("REPORT.VUE, typ changed, delete items...")
        this.items = []
        this.itemsHeaders = []
        this.lokality = []
        this.stanice = []
        this.body = []
        this.filterDatumDo = ""
        this.filterDatumOd = ""
        this.filterLokalitaId = ""
        this.filterStanicaId = ""
        this.filterBodId = []
        this.filterHlbky = ""
        this.readLokality()
      }
    },
    filterLokalitaId: {
      immediate: true,
      handler: function() {
        console.log("REPORT.VUE, filterLokalitaId changed, fetching body...")
        this.filterBodId = []
        this.readBody()
      }
    }
  },
  methods: {
    readLokalityInk: async function() {
      console.log("readLokalityInk start")
      this.lokality = []
      Promise.all([
        this.$axios.get("/r/lokality/mer_inks"),
        this.$axios.get("/r/lokality/mer_inkp")
      ])
        .then(
          function(results) {
            if (results[0].status === 200 && results[1].status === 200) {
              let ink = new Set()
              const inks = results[0].data
              const inkp = results[1].data
              inks.map(item => ink.add(item))
              inkp.map(item => ink.add(item))
              this.lokality = Array.from(ink) //uz unikatne lokality
            } else {
              this.$store.commit(
                "alert",
                results[0].data.Error + " " + results[1].data.Error
              )
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.commit("alert", error.toString())
          }.bind(this)
        )
    },
    readLokality: async function() {
      if (this.isTypZrazky) {
        return
      }
      if (this.typ === "ink") {
        this.readLokalityInk()
        return
      }
      try {
        this.lokality = []
        let response = await this.$axios.get("/r/lokality/" + this.merTable)
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readStanice: async function() {
      try {
        this.stanice = []
        let response = await this.$axios.get("/r/stanice")
        if (response.status === 200) {
          this.stanice = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBodyInk: async function() {
      this.body = []
      if (
        Miscella.isSet(this.filterLokalitaId) &&
        this.filterLokalitaId !== ""
      ) {
        let url = "/r/body/" + this.filterLokalitaId
        Promise.all([
          this.$axios.get(url + "/mer_inks"),
          this.$axios.get(url + "/mer_inkp")
        ])
          .then(
            function(results) {
              if (results[0].status === 200 && results[1].status === 200) {
                let ink = new Set()
                const inks = results[0].data
                const inkp = results[1].data
                inks.map(item => ink.add(item))
                inkp.map(item => ink.add(item))
                let body = Array.from(ink) //uz unikatne body
                for (let i = 0; i < body.length; i++) {
                  let bod = body[i]
                  bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
                  bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
                  bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
                  bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
                }
                this.body = body
              } else {
                this.$store.commit(
                  "alert",
                  results[0].data.Error + " " + results[1].data.Error
                )
              }
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.commit("alert", error.toString())
            }.bind(this)
          )
      }
    },
    readBody: async function() {
      if (this.isTypZrazky) {
        return
      }
      if (this.typ === "ink") {
        this.readBodyInk()
        return
      }
      try {
        console.log("Report.vue, readBody, id=" + this.filterLokalitaId)
        this.body = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            "/r/body/" + this.filterLokalitaId + "/" + this.merTable
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.body = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    showReport: async function() {
      try {
        console.log("Report.vue, showReport")
        this.items = []
        this.itemsHeaders = []
        this.loading = true
        /*
        let urlX =
          "/report/" +
          this.typ +
          "?lokalitaid=" +
          Miscella.normalizeString(this.filterLokalitaId) +
          "&bodid=" +
          Miscella.normalizeString(this.filterBodId) +
          "&datumod=" +
          Miscella.formatDatumEx(this.filterDatumOd, "YYYY-MM-DD") +
          "&datumdo=" +
          Miscella.formatDatumEx(this.filterDatumDo, "YYYY-MM-DD")
        if (this.typ === "ink") {
          urlX += "&hlbky=" + Miscella.normalizeString(this.filterHlbky)
        }
        if (this.isTypZrazky) {
          urlX += "&stanicaid=" + Miscella.normalizeString(this.filterStanicaId)
        }
        console.log("urlX", urlX)
        */
        let url = Miscella.url("/report/" + this.typ)
        url.searchParams.append(
          "lokalitaid",
          Miscella.normalizeString(this.filterLokalitaId)
        )
        url.searchParams.append("bodid", this.filterBodId.toString())
        url.searchParams.append(
          "datumod",
          Miscella.formatDatumEx(this.filterDatumOd, "YYYY-MM-DD")
        )
        url.searchParams.append(
          "datumdo",
          Miscella.formatDatumEx(this.filterDatumDo, "YYYY-MM-DD")
        )
        if (this.typ === "ink") {
          url.searchParams.append(
            "hlbky",
            Miscella.normalizeString(this.filterHlbky)
          )
        }
        if (this.isTypZrazky) {
          url.searchParams.append(
            "stanicaid",
            Miscella.normalizeString(this.filterStanicaId)
          )
        }
        console.log("url", url)
        let response = await this.$axios.get(url)
        this.loading = false
        if (response.status === 200) {
          this.items = response.data.data
          if (this.items === null) {
            this.items = []
          }
          this.itemsHeaders = response.data.headers
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.loading = false
        this.$store.commit("alert", error.toString())
      }
    }
  },
  mounted: async function() {
    console.log("report.vue mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokality()
    this.readStanice()
  }
}
</script>
